// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import DateUtils from '../utils/DateUtils';

export default class News extends ApiObject {

  id: string = '';

  creationDate: number = 0;

  title: string = '';

  content: string = ''; // Default value is the current display date.

  picture: string = '';

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);
  }

  getFormattedDate(format: string = 'dddd DD/MM/Y'): string {
    return DateUtils.fromSecondsTimestampToString(this.creationDate / 1000, format);
  }

  getFormattedHour(format: string = 'HH:mm'): string {
    return DateUtils.fromSecondsTimestampToString(this.creationDate / 1000, format);
  }

  getMomentDate() {
    return DateUtils.fromTimestamp(this.creationDate, DateUtils.MS_FORMAT);
  }

  getHour(): number {
    return DateUtils.fromTimestamp(this.creationDate, DateUtils.MS_FORMAT).hour();
  }

  isValid(): boolean {
    return !_.isEmpty(this.title) && !_.isEmpty(this.content);
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/News.js